import { AdacText } from '@adac-de/component-library';
import { clsx } from 'clsx';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Partners } from '../../../types';
import { PartnerSelectionFormFields } from '../form-steps/partner-selection';
import styles from './partner-checkbox.module.scss';
import { List } from '@components/list/list';
import { Icon } from '@components/icons/icons';
import { CloudinaryImage } from '@components/cloudinary-image/cloudinary-image';

type PartnerCheckboxProps = {
  box: PartnerBox;
  error: boolean;
};

export const PartnerCheckbox: React.FC<PartnerCheckboxProps> = ({ box, error }) => {
  const { control, register } = useFormContext<PartnerSelectionFormFields>();

  const selectedPartners = useWatch<PartnerSelectionFormFields, 'partners'>({
    control,
    name: 'partners'
  });

  const isPartnerSelected = selectedPartners.includes(box.partner as Partners);

  return (
    <label
      className={clsx({
        [styles.checkboxContainer]: true,
        [styles.checked]: isPartnerSelected
      })}
    >
      <div className={styles.checkboxContent}>
        <div className={styles.checkboxLeftCol}>
          {box.logo && <CloudinaryImage {...box.logo} className={styles.checkboxImage} />}
          <div className={styles.checkboxText}>
            <AdacText className="margin-bottom--xs" bold type="medium">
              {box.partner}
            </AdacText>
            <List listItems={box.listItems} listItemClassName={styles.listItem} textType="medium" />
          </div>
        </div>
        <input
          type="checkbox"
          className={styles.checkboxInput}
          {...register('partners', {
            validate: value => value.length > 0
          })}
          value={box.partner}
        />
        <Icon.Check
          fill={isPartnerSelected ? 'highlight' : 'white10'}
          className={clsx({
            [styles.checkboxIcon]: true,
            [styles.checked]: isPartnerSelected,
            [styles.checkboxError]: error
          })}
        />
      </div>
    </label>
  );
};
